"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearcher = void 0;
var React = require("react");
var Keyboard_1 = require("../_Core/Keyboard");
var useSearcher = function (OnSearch, OnCancel, options) {
    if (options === void 0) { options = {}; }
    var _a = React.useState(""), value = _a[0], setValue = _a[1];
    var _b = React.useState(false), isSearching = _b[0], setIsSearching = _b[1];
    var ref = React.useRef(null);
    var searchTimeout = React.useRef(0);
    React.useEffect(function () {
        return function () { return window.clearTimeout(searchTimeout.current); };
    }, []);
    var onKeyUp = function (e) {
        window.clearTimeout(searchTimeout.current);
        if (Keyboard_1.IsEscape(e)) {
            triggerCancel();
        }
        else if (Keyboard_1.IsEnter(e)) {
            triggerSearch();
        }
        else {
            if (value.length >= 3) {
                searchTimeout.current = window.setTimeout(function () {
                    triggerSearch();
                }, 500);
            }
            if (options.TriggerCancelOnEmptyString && value.length === 0) {
                triggerCancel();
            }
        }
    };
    var onChange = function (e) {
        setValue(e.target.value);
    };
    var triggerSearch = function () {
        window.clearTimeout(searchTimeout.current);
        if (value.length > 0) {
            setIsSearching(true);
            OnSearch(value).then(function () {
                setIsSearching(false);
            });
        }
    };
    var triggerCancel = function () {
        window.clearTimeout(searchTimeout.current);
        setValue("");
        setIsSearching(true);
        OnCancel().then(function () {
            setIsSearching(false);
            if (ref.current) {
                ref.current.focus();
            }
        });
    };
    var type = "search";
    var hasSearchValue = value.length > 0;
    return {
        hasSearchValue: hasSearchValue,
        inputProps: {
            onChange: onChange,
            onKeyUp: onKeyUp,
            ref: ref,
            type: type,
            value: value,
        },
        isSearching: isSearching,
        triggerCancel: triggerCancel,
        triggerSearch: triggerSearch,
    };
};
exports.useSearcher = useSearcher;
